export default __webpack_public_path__ + "static/media/Graphik-ThinItalic.6951dd75.otf";